import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@app/shared/custom-input-validators';

@Component({
    selector: 'app-user-reason-form',
    template: `
        <div [formGroup]='reasonForm'>
            <ag-input
                id="delete-reason"
                [errorMessage]="getErrorMsg()"
                [maxlength]="maxlength"
                formControlName="userReason"
                [label]="required ? label + ' *' : label"></ag-input>
        </div>
    `
})
export class AppUserReasonFormComponent implements OnChanges, OnInit {

    @Input() maxlength = 255;
    @Input() disabled: boolean;
    @Input() required = true;
    @Input() value: string;
    @Input() label = 'Please provide a reason';
    @Output() formReady = new EventEmitter<FormGroup>();
    reasonForm: FormGroup;
    validators = [
        CustomValidators.blankField('Reason'),
        CustomValidators.invalidReasonCheck()
    ];

    ngOnInit() {
        if (this.required) {
            this.validators.push(Validators.required);
        }
        this.reasonForm = new FormGroup({
            'userReason': new FormControl({ value: '', disabled: false }, this.validators)
        });
        // Emit the form to parent
        this.formReady.emit(this.reasonForm);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && !changes.value.firstChange) {
            this.reasonForm.patchValue({ 'userReason': this.value });
        }
        if (changes.disabled) {
            this.disableReasonInputField(changes.disabled.currentValue);
        }
        if (changes.required && !changes.required.firstChange) {
            this.setRequiredValidatorOrNot(changes.required.currentValue);
        }
    }

    setRequiredValidatorOrNot(isRequired: boolean) {
        if (isRequired) {
            this.reasonForm.setValidators(Validators.required);
            this.reasonForm.updateValueAndValidity();
        }
    }

    disableReasonInputField(disabled: boolean) {
        setTimeout(() => {
            const control = this.reasonForm.get('userReason');
            disabled ? control.disable() : control.enable();
        });
    }

    getErrorMsg() {
        const control = this.reasonForm.get('userReason');
        const errors = control.errors || {};
        if (control.touched && 'required' in errors) {
            return 'This field is required';
        }

        // Handle our custom validators error message
        const errorObj = Object.values(errors)[0];
        if (errorObj && errorObj.hasOwnProperty('errorLabel')) {
            return errorObj['errorLabel'];
        }
    }
}
